import { memo, useEffect } from 'react';

import { Grid } from '@mui/material';
import { FastField, FastFieldProps } from 'formik';

import { TipoOperacaoAutoComplete } from 'components/autocompletes/TipoOperacaoAutoComplete';
import { Row } from 'components/form';
import { SubTitle } from 'components/text';
import { useLoaderContext } from 'context/LoaderContext';
import { useQueryTiposLojas } from 'pages/compra/configuracao-pedido/hooks';
import { ConfigPedidoOperacoes } from 'pages/compra/configuracao-pedido/types';

interface ConfigPedidoTiposLojasProps {
    configPedidoOperacoes: ConfigPedidoOperacoes[];
    idConfigPedido: number | null | undefined;
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
}

export const ConfigPedidoTiposLojas = memo(({ configPedidoOperacoes, idConfigPedido, setFieldValue }: ConfigPedidoTiposLojasProps) => {
    const { data: tiposLojas, isFetching } = useQueryTiposLojas();

    useEffect(() => {
        if (tiposLojas && (!configPedidoOperacoes || configPedidoOperacoes.length === 0)) {
            setFieldValue(
                'configPedidoOperacoes',
                tiposLojas.map((tipoLoja) => ({
                    tipoLoja,
                })),
            );
        }
    }, [tiposLojas]);

    useLoaderContext(isFetching);

    if (!configPedidoOperacoes || configPedidoOperacoes.length === 0) return null;

    return (
        <>
            <SubTitle label="Tipo de lojas" />

            {configPedidoOperacoes.map((configPedidoOperacao, index) => (
                <FastField name={`configPedidoOperacoes[${index}].operacao`} key={index}>
                    {({ field, meta, form }: FastFieldProps) => (
                        <Row>
                            <Grid sx={{ flex: 1 }}>
                                <TipoOperacaoAutoComplete
                                    label={`Operação de Loja ${configPedidoOperacao.tipoLoja.dsTipoLoja}`}
                                    name={field.name}
                                    value={field.value}
                                    error={meta.error}
                                    onChange={(e, value) => {
                                        form.setFieldValue(`configPedidoOperacoes[${index}]`, {
                                            tipoLoja: configPedidoOperacao.tipoLoja,
                                            operacao: value,
                                            idConfigPedidoOperacao: configPedidoOperacao.idConfigPedidoOperacao ?? null,
                                            idConfigPedido: Number(idConfigPedido),
                                        });
                                    }}
                                />
                            </Grid>
                        </Row>
                    )}
                </FastField>
            ))}
        </>
    );
});
